import React, { useContext } from 'react';
import { CarlineWithOffers } from 'src/types';

export const FormContext = React.createContext<{
  openCallMeNow: () => void;
  closeCallMeNow: () => void;
  openLead: () => void;
  closeLead: () => void;
  formSmall: boolean;
  overflowVisible: boolean;
  formAutoWidth: () => void;
    }>(undefined);
